import { SelectInput } from '@core/components/Select';
import React from 'react';

const DreList = ({ dres, selecionado, onChange, onBlur, id, name }) => {
  return (
    <SelectInput
      id={id}
      name={name}
      label="DRE"
      onChange={onChange}
      onBlur={onBlur}
      value={selecionado}
      options={dres.map((_dre) => ({ id: _dre.id, title: _dre.descricao }))}
      openOnFocus
      error={false}
      touched={false}
    />
  );
};

export default DreList;
